<script>
  import { page } from '@inertiajs/svelte';
  import viewport from '@/js/utils/useViewportAction.js';
  import responsive from '@/js/utils/responsive';
  import Nav from './Nav.svelte';
  import Section from './Section.svelte';

  export let preview;

  let innerWidth = 0;
  $: mobile = innerWidth <= responsive.s;

  let active = '';
  let grow = false;
  /**
   * Handle the active section
   */
  function handleVisible(e) {
    const section = e.detail;
    active = section.id;
  }

  /**
   * Handle scroll to active section
   */
  function handleNavClick(e) {
    const section = e.detail;
    const sectionEl = document.getElementById(section.id);
    sectionEl.scrollIntoView({ behavior: 'smooth' });
  }

  console.log(innerWidth);
</script>

<svelte:window bind:innerWidth />

<section class="preview">
  <div class="container">
    {#if preview.title}
      <h2 class="h3 preview__title">{preview.title}</h2>
    {/if}
  </div>

  <Nav nav={preview} {active} on:showActive={handleNavClick} />
  {#if !mobile}
    <div class="container">
      <div
        class="p-note"
        class:grow
        use:viewport
        on:enterViewport={() => (grow = true)}
      >
        <div class="p-note__img">
          <img
            src={`${$page.props.asset_url}img/hand.svg`}
            width="20"
            height="20"
            alt="Cursor pointer"
            loading="lazy"
          />
        </div>
        <p class="p-note__text text-small">
          {$page.props.i18n.page.use_hand_gesture}
        </p>
      </div>
    </div>
  {/if}
  {#each preview.items as section}
    <div class="section-wrap">
      <div class="container container--large">
        <Section {section} on:showActive={handleVisible} />
      </div>
    </div>
  {/each}
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .preview {
    @include resp-max('s') {
      padding-bottom: 0;
    }
    &__title {
      margin-bottom: 3rem;
      text-align: center;

      @include resp-max('s') {
        @include h2;
      }
    }
  }

  .p-note {
    display: flex;
    align-items: center;
    gap: 1.7rem;

    max-width: 35.4rem;
    margin: 3rem auto 8rem;

    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }
    &__img {
      display: flex;
      align-items: center;
      justify-content: center;

      width: 5rem;
      height: 5rem;

      border-radius: 50%;
      border: 1px solid $light-border;

      img {
        width: 2rem;
      }
    }

    &__text {
      color: var(--royal-light);
      flex: 1;
    }
  }

  .section-wrap {
    @include resp-max('s') {
      border-top: 1px solid $light-border;
    }
  }
</style>
